import foffJobsCrcCodes from '@nike/ux-tread-crc-code/lib/buy/fulfillment_offerings_jobs/v1/crcCodes';
import {
  ON_FETCH_FAILURE,
  ON_FETCH_START,
  ON_FULFILLMENT_OFFERINGS_SUCCESS,
  SHOP_STATE_KEY,
} from '../../action-types';

const CLEAR_ERRORS = `${SHOP_STATE_KEY}/CLEAR_ERRORS`;

const errorsReducer = (state = [], action = {}) => {
  switch (action.type) {
    case ON_FETCH_FAILURE: {
      return [
        ...state,
        {
          code: action.payload?.code,
          message: action.payload?.message,
          crcCode: action.payload?.crcCode,
          itemId: action.payload?.itemId,
        },
      ];
    }
    case CLEAR_ERRORS:
      return [
        ...state.filter(
          // This error has UI associated with it. The user cannot clear this
          // error without deliberately removing the offending item from their cart.
          // Therefor, we can't delete this error from the local store and it must be
          // removed with a successful API response
          errorWarning => errorWarning.crcCode === foffJobsCrcCodes.FULFILLMENT_OFFERINGS_NOT_FOUND,
        ),
      ];
    case ON_FULFILLMENT_OFFERINGS_SUCCESS:
      return [
        ...state.filter(
          // If an F/Off API response comes back successful we must manually remove previous errors
          errorWarning => errorWarning.crcCode !== foffJobsCrcCodes.FULFILLMENT_OFFERINGS_NOT_FOUND,
        ),
      ];

    // If we keep around state from old f/off calls, we'll just accumulate a lot of errors.
    // ON_FETCH_START can be triggered by other calls, but we'll regain errors from API responses.
    case ON_FETCH_START:
      return [];

    default:
      return state;
  }
};

export default errorsReducer;
